import { useAppDispatch, useAppSelector } from "@builder/store/store";
import TextInput from "../TextInput";
import { getOnClickTarget, getSelectedNode, getSelectedNodeActionBuilder } from "@builder/store/slices/BuilderSlice/builderSelectors";
import { setActionFromNode, setActionPath, setCurrentPopup } from "@builder/store/slices/popupSlice";
import { updateNodeActions } from "@builder/store/slices/BuilderSlice/builderSlice";
import { ActionBuilderType, reconstructActionEditor } from "@builder/utils/actionBuilderHelpers";
import { setActionsEditor, setCurrent } from "@builder/store/slices/actionBuilderSlice";
import "./style.scss";
import TooltipElement from "../Tooltip";
import { useTranslation } from "react-i18next";

interface ActionSelectorInputProps {
    actionId?: string;
    actionPath?: string | null;
}

const ActionSelectorInput = ({ actionPath, actionId }: ActionSelectorInputProps) => {
    const dispatch = useAppDispatch();
    const targetName = useAppSelector(getOnClickTarget) || "";
    const iconAction = targetName ? "/x-icon-small-bright.svg" : "/actions-icon.svg";
    const iconAction2 = targetName ? "/bolt.svg" : "";
    const node = useAppSelector(getSelectedNode);
    const selectedNodeActionBuilder = actionId
        ? useAppSelector(state => state.builder.build.actionBuilder?.[actionId])
        : useAppSelector(getSelectedNodeActionBuilder);
    const { t } = useTranslation();

    const handleOpenAction = () => {
        if (node) {
            dispatch(setActionFromNode(true));
        }
        if (actionPath) {
            dispatch(setActionPath(actionPath));
        }
        dispatch(setCurrentPopup("actions"));
    };

    const handleExistingOpenAction = () => {
        if (selectedNodeActionBuilder) {
            if (node) {
                dispatch(setActionFromNode(true));
            }
            if (actionPath) {
                dispatch(setActionPath(actionPath));
            }
            const actionsEditor = reconstructActionEditor(selectedNodeActionBuilder);
            dispatch(setCurrentPopup("actionBuilder"));
            dispatch(setActionsEditor(actionsEditor));
            dispatch(setCurrent({ id: actionsEditor[0].id || "", tab: ActionBuilderType.START }));
        }
    };

    const handleRemoveAction = () => {
        setTimeout(() => dispatch(updateNodeActions()), 0);
    };

    return (
        <TooltipElement text={t("tooltip.elementAction")} position="bottom">
            <span className="action-selector-input-wrapper">
                <TextInput
                    onClick={selectedNodeActionBuilder ? handleExistingOpenAction : handleOpenAction}
                    title="Actions"
                    placeholder="No actions selected"
                    value={targetName || selectedNodeActionBuilder?.name || ""}
                    callback={() => {}}
                    readOnly={true}
                    className={targetName ? "action-selector-has-data" : ""}
                    icon={{
                        src: iconAction,
                        callback: (event: React.MouseEvent) => {
                            event.preventDefault();
                            event.stopPropagation();
                            if (targetName) {
                                handleRemoveAction();
                            } else {
                                handleOpenAction();
                            }
                        }
                    }}
                    icon2={{
                        src: iconAction2,
                        callback: (event: React.MouseEvent) => {
                            event.preventDefault();
                            event.stopPropagation();
                            if (targetName) {
                                handleOpenAction();
                            }
                        }
                    }}
                />
            </span>
        </TooltipElement>
    );
};

export default ActionSelectorInput;
